export const getCustomDomainCnameValue = (isDevEnv: boolean) =>
	isDevEnv ? 'rentle.club' : 'rentle.domains';

export const getIsCnameValid = (cname: string, args: { isDevEnv: boolean }): boolean => {
	const validHostname = getCustomDomainCnameValue(args.isDevEnv);
	return cname === validHostname;
};

export const getCustomDomainARecordValue = (isDevEnv: boolean) =>
	isDevEnv ? '34.96.112.111' : '34.110.208.101';

export const getIsARecordValid = (aRecord: string, args: { isDevEnv: boolean }) => {
	const validARecord = getCustomDomainARecordValue(args.isDevEnv);
	return validARecord === aRecord;
};
